(function () {

  'use strict';

  /**
    Configuration and requirements
    // note, that this directive acts as a container for other directives,
    //and it is responible connect the contained directive with eachother and with the controller
    -----------------
    popupObject: {
      dimensions: { height: number, widht: number}, //
      offset: { top: number, left: number}, // this is used to offset the popup relative its parent
      pointerDirection: null, // this will be set dynamically
      pointerPosition: string, // supports => right, left, center, up, middle, bottom
      relativePosition: string, // supports => over, under, left, right (note: left + left is not possible)
      type: string, // supports => SIMPLE_SELECT, COMBINED_SELECT_INPUT
      title: string,
      confirmText: string
    }
    childDirectiveDataObject {}
    // this object is passed along to the directives the subDirectives, we support ['pxSelect', 'pxInput']
    // for specific requirements goto the .js files and read the documentation
  */

  function pxPopupNested($timeout) {
    return {
      restrict: 'EA',
      scope: {
        childDirectiveDataObject: "=childDirectiveDataObject",
        popupObject: '=popupObject',
        clearNestedPopup: '&clearNestedPopup',
        nestedCallback: '&nestedCallback'
      },
      templateUrl: 'app/directives/popupNested/popup-nested.template.html',
      link: function(scope, element) {

        scope.subDirectiveData = scope.childDirectiveDataObject;
        scope.nestedConfirmEnabled = false;
        scope.title = scope.popupObject.title;
        scope.confirmText = scope.popupObject.confirmText;
        scope.pointerDistance = 5;
        scope.resetPagination = false;
        scope.checkboxValue  = null;
        // scope.toggleAttachment = false;


        //*****************//
        // INIT
        // ------------------
        //  Open popup, set dimension and position
        //*****************//
        (function() {
          setClasses();
          setPopupProperties();
        })();

        scope.$watch(function () {
          return scope.childDirectiveDataObject;
        }, function () {
          scope.subDirectiveData = scope.childDirectiveDataObject;
        }, true)

        function setClasses() {
          angular.element('.pop-up-nested-container').show();
          angular.element('.pop-up-nested-container').parent().addClass('relative');
          angular.element('.pop-up-nested-container').addClass('openPopup');
        }

        function setPopupProperties() {
          setDimensions();
          setPositionRelative();
          setPointer ();
        }

        function setDimensions() {
          angular.element('.pop-up-nested-container').css({height: scope.popupObject.dimensions.height})
          angular.element('.pop-up-nested-container').css({width: scope.popupObject.dimensions.width})
        }

        function setPositionRelative() {
          var heightOfParent = angular.element('.pop-up-nested-container').parent().height();
          switch (scope.popupObject.relativePosition) {
            case 'over':
              angular.element('.pop-up-nested-container').css({top: -scope.popupObject.dimensions.height - scope.pointerDistance});
              setPositionRelativeHorizontal();
              break;
            case 'under':
              angular.element('.pop-up-nested-container').css({top: heightOfParent + scope.pointerDistance - scope.popupObject.offset.top});
              setPositionRelativeHorizontal();
              break;
            case 'left':
              angular.element('.pop-up-nested-container').css({left: -scope.popupObject.dimensions.width - scope.pointerDistance});
              setPositionRelativeHorizontal();
              setPositionRelativeVertical(heightOfParent);
              break;
            case 'right':
              angular.element('.pop-up-nested-container').css({left: scope.popupObject.offset.left + scope.pointerDistance});
              setPositionRelativeVertical(heightOfParent);
              break;
            default:
              angular.element('.pop-up-nested-container').css({top: -scope.popupObject.dimensions.height - scope.pointerDistance});
              setPositionRelativeHorizontal();
              break;
          }
        }

        function setPositionRelativeHorizontal() {
          switch (scope.popupObject.pointerPosition) {
            case 'right':
              angular.element('.pop-up-nested-container').css({left: -scope.popupObject.dimensions.width + scope.popupObject.offset.left});
              break;
            case 'left':
              angular.element('.pop-up-nested-container').css({left: scope.popupObject.offset.left});
              break;
            case 'center':
              angular.element('.pop-up-nested-container').css({left: -scope.popupObject.dimensions.width / 2 + (scope.popupObject.offset.left / 2)});
              break;
            default:
              angular.element('.pop-up-nested-container').css({left: -scope.popupObject.dimensions.width / 2 + (scope.popupObject.offset.left / 2)});
            break;
          }

        }

        function setPositionRelativeVertical() {
          switch (scope.popupObject.pointerPosition) {
            case 'up':
              angular.element('.pop-up-nested-container').css({top: -scope.popupObject.offset.top / 2}); // FIGURE OUT THIS, I dont like this hardcoded value.
              break;
            case 'middle':
              angular.element('.pop-up-nested-container').css({top: -scope.popupObject.dimensions.height / 2 + (scope.popupObject.offset.top / 2)});
              break;
            case 'bottom':
            angular.element('.pop-up-nested-container').css({bottom: (-scope.popupObject.offset.top / 2) + 8}); // FIGURE OUT THIS, I dont like this hardcoded value.
              break;
            default:
              break;
          }
        }

        function setPointer() {
          var relativePosition = scope.popupObject.relativePosition;

          switch (relativePosition) {
            case 'under':
              scope.popupObject.pointerDirection = 'top'
              break;
            case 'over':
              scope.popupObject.pointerDirection = 'bottom'
              break;
            case 'left':
              scope.popupObject.pointerDirection = 'right'
              break;
            case 'right':
              if (!scope.popupObject.pointerDirection === 'right') {
                scope.popupObject.pointerDirection = 'left'
              }
            break;
          }

          var pointerPlacement = 'pointer-' + scope.popupObject.pointerDirection + '__' + scope.popupObject.pointerPosition;
          angular.element(".pop-up-nested-content").addClass(pointerPlacement);
        }

        scope.closeNestedPopup = function() {
          angular.element(".pop-up-nested-container").hide();
          angular.element(".pop-up-nested-container").removeClass(scope.popupObject.type);
          scope.resetPagination = true;
          scope.clearNestedPopup();
        }

        scope.closeNestedPopupOutside = function() {
          if (scope.popupObject.nestedClickOutsideToClose) {
            angular.element(".pop-up-nested-container").hide();
            angular.element(".pop-up-nested-container").removeClass(scope.popupObject.type);
            scope.resetPagination = true;
            scope.clearNestedPopup();
          }
        }

        scope.nestedSelectedItem = function (item, enableConfirm, selectedAttachmentItem) {
          nestedsetConfirm(enableConfirm);
          scope.selectAttachedItem = selectedAttachmentItem;
          scope.selectItem = item;
        }

        scope.nestedInputItem = function (input, enableConfirm) {
          nestedsetConfirm(enableConfirm);
          scope.inputItem = input;
        }

        // scope.inputSelectItem = function (item, enableConfirm) {
        //   setConfirm(enableConfirm);
        //   scope.inputItem = item;
        // }

        // scope.setInputItem = function(item, enableConfirm) {
        //   setConfirm(enableConfirm);
        //   scope.inputItem = item;
        // }

        // scope.setCheckboxValue = function(value) {
        //   scope.checkboxValue = value;
        // }

        // scope.toggleAttachment = function() {
        //   scope.toggleAttachment = !scope.toggleAttachment;
        // }

        function nestedsetConfirm(enableConfirm) {
          if (enableConfirm) {
            scope.nestedConfirmEnabled = true;
          } else {
            scope.nestedConfirmEnabled = false;
          }
        }

        scope.nestedConfirm = function (boolean) {
          switch (scope.popupObject.type) {
            case 'SIMPLE_SELECT':
              scope.nestedCallback({item: scope.selectItem});
            break;
            case 'PAGINATION':
              scope.nestedCallback({item: scope.selectItem});
            break;
            // case 'PAGINATION_ATTACHED_SELECT':
            //   scope.callback({item: scope.selectItem, attachedItem: scope.selectAttachedItem});
            // break;
            case 'SIMPLE_INPUT':
              scope.nestedCallback({item: scope.inputItem});
            break;
            // case 'COMBINED_SELECT_INPUT':
            //   scope.callback({item: scope.inputItem});
            // break;
            // case 'SIMPLE_INPUT_AND_CHECKBOX':
            //   scope.inputItem.checkboxValue = scope.checkboxValue;
            //   scope.callback({item: scope.inputItem});
            // break;
            // case 'CONFIRM':
            //   if (boolean) {
            //     scope.callback();
            //   }
            break;
          }
          scope.closeNestedPopup();
        }



        element.on("keydown keypress", function (event) {
          if(event.which === 13) {
              scope.$apply(function (){
                if (scope.nestedConfirmEnabled) {
                  scope.nestedConfirm();
                }
              });
              event.preventDefault();
          }
      });

      }
    };
  }

  pxPopupNested.$inject = ['$timeout'];

  angular
    .module('printix-admin')
    .directive('pxPopupNested', pxPopupNested);

})();